import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import { Box, Link, TextField, Typography } from '@mui/material';
import React from 'react';

import { semantic } from '@diligentcorp/atlas-design-tokens/lens';
import { InvestigationStep } from './types';

interface InvestigationStepRowProps {
  step: InvestigationStep;
  index: number;
  isEditing: boolean;
  editedStep?: { title: string; description: string };
  hasFindings: boolean;
  onTitleChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onViewFindings: () => void;
}

export const InvestigationStepRow: React.FC<InvestigationStepRowProps> = ({
  step,
  index,
  isEditing,
  editedStep,
  hasFindings,
  onTitleChange,
  onDescriptionChange,
  onViewFindings,
}) => (
  <Box display="flex" alignItems="flex-start" sx={{ mb: 3 }}>
    <CheckCircleOutlineIcon
      color="primary"
      sx={{
        mr: 1.5,
        mt: 0.25,
        fontSize: semantic.iconSize.md.value,
        flexShrink: 0,
      }}
    />
    <Box flex={1}>
      {isEditing ? (
        <>
          <TextField
            fullWidth
            size="small"
            value={editedStep?.title ?? step.title}
            onChange={(e) => onTitleChange(e.target.value)}
            sx={{ mb: 1 }}
            inputProps={{ 'aria-label': `Step ${index + 1} title` }}
          />
          <TextField
            fullWidth
            size="small"
            multiline
            minRows={2}
            value={editedStep?.description ?? step.description}
            onChange={(e) => onDescriptionChange(e.target.value)}
            inputProps={{ 'aria-label': `Step ${index + 1} description` }}
          />
        </>
      ) : (
        <>
          <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
            {step.title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: 1.5 }}
          >
            {step.description}
          </Typography>
          {step.hasSpecialAction && (
            <Link
              href="#"
              variant="body2"
              sx={{
                mt: 0.75,
                display: 'inline-flex',
                alignItems: 'center',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
              onClick={(e) => {
                e.preventDefault();
                if (hasFindings) onViewFindings();
              }}
            >
              <DescriptionIcon
                sx={{ mr: 0.5, fontSize: semantic.iconSize.sm.value }}
              />
              View Findings
            </Link>
          )}
        </>
      )}
    </Box>
  </Box>
);
